import { Message } from 'rsuite'
import useTranslation from '@/hooks/useTranslation'

export default function PreviewModeBanner() {
  const t = useTranslation()
  return (
    <Message showIcon type="warning" style={{ marginBottom: '10px', borderRadius: '0' }}>
      <strong>{t('preview_mode', 'Preview Mode')}</strong> -{' '}
      {t('preview_mode_message', 'You are viewing draft changes that have not been published yet.')}
    </Message>
  )
}
